import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-row-action',
  templateUrl: './row-action.component.html',
  styleUrls: ['./row-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowActionComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams & {
    selectedId: Observable<number>;
    dataLenght: Observable<number>;
    canCopy: boolean;
  };
  selectedId!: Observable<number>;
  dataLenght!: Observable<number>;
  canCopy = false;

  constructor() {}
  refresh(
    params: ICellRendererParams & { selectedId: Observable<number>; dataLenght: Observable<number>; canCopy: boolean },
  ): boolean {
    return true;
  }

  agInit(
    params: ICellRendererParams & {
      selectedId: Observable<number>;
      dataLenght: Observable<number>;
      canCopy: boolean;
    },
  ): void {
    this.params = params;
    this.dataLenght = params.dataLenght;
    this.selectedId = params.selectedId;
    this.canCopy = params.canCopy;
  }

  onCopy(): void {
    this.params.context.componentParent.cellMethodCopy(this.params.data.id);
  }

  openDelete(): void {
    this.params.context.componentParent.cellMethodDelete(this.params.data.id);
  }

  goto() {
    this.params.context.componentParent.goTo();
  }
}
